const Footer = () => {
  return (
    <>
      {/* Footer Section */}
      <div className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="footer-logo">
                <img src="/assets/images/logo.png" alt="Logo" />
              </div>
              <div className="footer-text">
                <p>Desenvolvimento de sistemas web, mobile e automatização de processos.</p>
              </div>
              <div className="footer-address">
                <div className="footer-social-icon">
                  <ul>
                    <li><a href="https://www.facebook.com/profile.php?id=61574968697330" target="blank"><i className="fab fa-facebook-f"></i></a></li>
                    <li><a className="style3" href="https://www.linkedin.com/in/vicente-carvalho-33954ab5" target="blank"><i className="fab fa-linkedin-in"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer-title">
                {/* Título vazio */}
              </div>
              <div className="footer-menu">
                {/* Menu vazio */}
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer-title">
                {/* Título vazio */}
              </div>
              <div className="footer-menu">
                {/* Menu vazio */}
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer-title">
                <h2><span>C</span>ontact</h2>
              </div>
              <div className="footer-contact">
                <ul>
                  <li><i className="fas fa-phone-volume"></i> (+55) 11 94811-2823</li>
                  <li><i className="fas fa-envelope-open-text"></i> 23.154.695/0001-61</li>
                  <li><i className="fas fa-map-marker-alt"></i>São Bernardo do Campo, São Paulo, Brasil 09853660</li>
                </ul>
              </div>
            </div>
          </div> 
        </div>
      </div>
      
      {/* Footer Copyright Section */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="copy-right-text">
                <p>Copyright © 2025. All rights reserved To <b>SpecsBR</b></p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="footer-menu-right">
                <ul>
                  <li><a className="br-none" href="#">Política de privacidade</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;